import Cookies from "js-cookie";

const cookies = document.querySelector(".cookies");
const btn = document.querySelector(".cookies__accept");
const info = document.querySelector(".info-box");
const infoClose = document.querySelector(".info-box__close");

if (Cookies.get("cookies") === "yes") {
} else {
  cookies.style.display = "block";
}

btn.addEventListener("click", function () {
  Cookies.set("cookies", "yes", { expires: 30 });
  cookies.style.display = "none";
});

if (info != null) {
  if (Cookies.get("info") === "yes") {
  } else {
    info.style.display = "block";
  }

  infoClose.addEventListener("click", function () {
    Cookies.set("info", "yes", { expires: 30 });
    info.style.display = "none";
  });
}
